<template>
    <div class="modal fade custom-right-modal" id="quotationRemindersModal">
        <div class="modal-dialog" style="max-width: 1140px !important;">
            <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header">
                    <h4 class="modal-title">Reminders</h4>
                    <a href="javascript:void(0)" class="pull-right add-btn" data-toggle="modal" data-target="#addReminderModal"><i class="fas fa-plus"></i></a>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <div v-if="errorMessage" class="alert alert-danger alert-dismissible">
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li>{{ errorMessage }}</li>
                        </ul>
                    </div>
                    <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li v-for="(v, k) in commonErrors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </li>
                        </ul>
                    </div>
                    <div class="modal-body new-taskAdd">
                        <template v-if="reminders && reminders.data && reminders.data.length">
                            <template v-for="(item, index) in reminders.data">
                                <div class="task-d">
                                    <div class="task-bg">
                                        <div class="small-heading">{{item.title}}</div>
                                        <span class="pull-right lght-clr">{{formatReminderDaySince(item)}} </span>
                                        <p>{{item.details}}</p>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="light-clr">Due Date</div>
                                                <p class="number">{{item.due_date != null && item.due_date != '' && item.due_date != '0000-00-00' ? item.due_date : '-'}}</p>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="light-clr">Assigned to</div>
                                                <p class="number">
                                                    <template v-for="(admin, adminIndex) in item.admins">
                                                        <template v-if="adminIndex > 0">,</template>
                                                        {{ admin.name }}
                                                    </template>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                        <template v-else><center>No reminder found</center></template>
                    </div>


                </div>

                <!-- Modal footer -->
                <div class="modal-footer">

                </div>

            </div>
        </div>
        <AddReminder :reminder="null" :quotation="quotation" :user="getAuthUser" @addedEvent="reminderAddedEvent" @updatedEvent="reminderUpdatedEvent"></AddReminder>

    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import AddReminder from "./AddReminder";

export default {
    name: "QuotationRemindersModal",
    props: ['quotation', 'bus'],
    components:{AddReminder},
    created() {
        this.getReminders();
    },
    mounted() {
    },
    data() {
        return {
            reminders: null
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),

        reminderAddedEvent(event){
            this.getReminders();
            $('#addReminderModal').modal('hide');
        },
        reminderUpdatedEvent(event){
            this.getReminders();
            $('#addReminderModal').modal('hide');
        },
        formatReminderDaySince(item){
            let c_date = new Date();
            let d_date = new Date(item.created_at);
            let Difference_In_Time = (c_date.getTime()) - (d_date.getTime())
            let day = (Math.ceil(Difference_In_Time/1000/60/60/24));
            if(day == 0){
                day ="Today"
            } else if(day == 1){
                day = day +' day ago'
            } else {
                day = day +' days ago'
            }

            return day;
        },
        getReminders(){
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios.get(window.route('dashboard.reminders.index', {quotation_id: this.quotation.id}), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.reminders = _.cloneDeep(data.data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        }

    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
        ])
    }
}
</script>

<style scoped>

</style>
